import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Language {
  code: string;
  labelKey: string;
}

export const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'en_AU', labelKey: 'general.languages.language1' },
  { code: 'ru_RU', labelKey: 'general.languages.language2' },
  { code: 'es_CO', labelKey: 'general.languages.language3' },
];

const DEFAULT_LANGUAGE = 'en_AU';
const STORAGE_KEY = 'app_language';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private readonly translate = inject(TranslateService);

  readonly supportedLanguages = SUPPORTED_LANGUAGES;

  readonly currentLang = signal<string>(DEFAULT_LANGUAGE);

  init(): void {
    const langs = SUPPORTED_LANGUAGES.map((l) => l.code);
    this.translate.addLangs(langs);
    this.translate.setFallbackLang(DEFAULT_LANGUAGE);

    const stored = localStorage.getItem(STORAGE_KEY);
    const resolved = stored && langs.includes(stored) ? stored : DEFAULT_LANGUAGE;

    this.currentLang.set(resolved);
    this.translate.use(resolved);
  }

  setLanguage(langCode: string): void {
    const isSupported = SUPPORTED_LANGUAGES.some((l) => l.code === langCode);
    if (!isSupported) {
      return;
    }

    localStorage.setItem(STORAGE_KEY, langCode);
    this.currentLang.set(langCode);
    this.translate.use(langCode);

    // TODO: call user preference API when available
    // this.userApi.updateLanguage(langCode).subscribe();
  }
}
